// extracted by mini-css-extract-plugin
export default {"container":"appRedirect_container__m9DFu","imageContainer":"appRedirect_imageContainer__kxsQM","textContainer":"appRedirect_textContainer__3rjC4"};